<template>
  <div class="flow-common-approval-form">
    <template v-if="formContainer">
      <component :is="formContainer" v-bind="formInfo"></component>
    </template>
    <template v-else>
      <div class="empty-hint">暂无表单数据</div>
    </template>
  </div>
</template>

<script>
import FlowCommonFormApproval from '../../form/approval'
import FlowCommonDataApproval from '../../data/approval'

export default {
  name: 'FlowCommonApprovalForm',
  props: {
    formInfo: {
      type: Object,
      default: null
    }
  },
  computed: {
    formContainer () {
      const formInfo = this.formInfo
      if (formInfo) {
        switch (formInfo.flowType) {
          case 'FORM_FLOW':
            return FlowCommonFormApproval
          case 'DATA_FLOW':
          default:
            return FlowCommonDataApproval
        }
      }
      return null
    }
  }
}
</script>
